export class TypeDureeMarche {

	public nbJours: number;

	public dateJusquau: string;

	public dateDebutTravaux: string;

	public dateACompterDu: string;

	public nbMois: number;

	public txtLibre: string;

	public dateDebutPrestation: string;

	constructor() { 
		 		this.nbJours = 0;
		this.dateJusquau = '';
		this.dateDebutTravaux = '';
		this.dateACompterDu = '';
		this.nbMois = 0;
		this.txtLibre = '';
		this.dateDebutPrestation = '';
 
	}
}
